import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { DeleteGroupRequest } from '../api/group/deletegroup/deletegrouprequest';
import { DeleteGroupResponse, DeleteGroupResponseDtoImpl } from '../api/group/deletegroup/deletegroupresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class DeleteGroupAPIProcessorImpl extends SixdeeCRBTAPIProcessor<DeleteGroupRequest, DeleteGroupResponse>
{
    execute(request: DeleteGroupRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try 
        {
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                let response = new DeleteGroupResponseDtoImpl(APIFeatures.DELETE_GROUP, "Delete Group Success");

                this.getAPISuccess(response);
            }
        }
        catch (e)
        {
            this.getAPIFailure(new DeleteGroupResponseDtoImpl(APIFeatures.DELETE_GROUP, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
   
            this.getAPIFailure(new DeleteGroupResponseDtoImpl(APIFeatures.DELETE_GROUP, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/deletegroupapiprocessor.tsx